import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import { SIGNUP_FORM_TYPES, USER_TYPES } from 'dpl/shared/constants/shared';
import UserAuthPageContainer from 'dpl/UserAuth/containers/UserAuthPageContainer';
import UserAuthInviteFormContainer from 'dpl/UserAuth/containers/UserAuthInviteFormContainer';
import LoginFormContainerV2 from 'dpl/auth/containers/LoginFormContainerV2';
import Logo from 'dpl/components/Logo';
import ForgotPasswordFormV2 from 'dpl/auth/components/ForgotPasswordFormV2';
import { isMobileUA } from 'dpl/shared/utils';

import UserAuthModalBreederSignupFormV2 from '../../UserAuthModalBreederSignupFormV2';
import SignupFormV2 from '../../SignupFormV2';
import UserAuthResetPasswordFormV2 from '../../UserAuthResetPasswordFormV2';

const {
  BREEDER_SIGNUP,
  FORGOT_PASSWORD,
  INVITE,
  LOGIN,
  RESET_PASSWORD,
  SIGNUP
} = SIGNUP_FORM_TYPES;

const IS_MOBILE_UA = isMobileUA();

export default function UserAuthAppV2() {
  return (
    <div className="vh-100 bg-sand ph5">
      <div className="bg-sand pb6">
        <div
          className="flex justify-center pv6 bb b--gray-300"
          style={{ marginBottom: IS_MOBILE_UA ? '56px' : '160px' }}
        >
          <div className="Header__logo primary">
            <Logo />
          </div>
        </div>
        <div style={{ maxWidth: '472px' }} className="m-auto">
          <BrowserRouter basename="/auth">
            <UserAuthPageContainer>
              <Switch>
                <Route
                  exact
                  path={`/${BREEDER_SIGNUP}/:referredBy?`}
                  component={UserAuthModalBreederSignupFormV2}
                />
                <Route
                  exact
                  path={`/${SIGNUP}`}
                  component={() => <SignupFormV2 userType={USER_TYPES.BUYER} />}
                />
                <Route
                  exact
                  path={`/${FORGOT_PASSWORD}`}
                  component={() => <ForgotPasswordFormV2 isCentered />}
                />
                <Route
                  exact
                  path={`/${INVITE}/:userId/:inviteToken/:conversationId?`}
                  component={UserAuthInviteFormContainer}
                />
                <Route
                  exact
                  path={`/${LOGIN}`}
                  component={LoginFormContainerV2}
                />
                <Route
                  exact
                  path={`/${RESET_PASSWORD}/:resetToken`}
                  component={UserAuthResetPasswordFormV2}
                />
                <Redirect to={`/${LOGIN}`} />
              </Switch>
            </UserAuthPageContainer>
          </BrowserRouter>
        </div>
      </div>
    </div>
  );
}
